<template>
  <router-view :key="$route.path"></router-view>
  <Toast ref="toast" />
  <NotificationToast ref="notificationToast" />
</template>

<script>
import { registerAppToast } from '@/utils/appToast';
import axios from 'axios'
import router from '@/router'
import {mapActions, mapStores} from 'pinia'
import {useAuthStore} from '@/stores/auth.js'
import echoInstance from "@/echo.js";
import Toast from '@/components/common/Toast.vue';
import NotificationToast from '@/components/common/NotificationToast.vue';
import {useNotificationsStore} from '@/stores/notifications.js';
import {usePushNotifications} from '@/composables/usePushNotifications.js';

export default {
  components: {
    Toast,
    NotificationToast
  },
  data: () => ({}),
  computed: {
    ...mapStores(useAuthStore),
    currentUser() {
      return this.authStore?.currentUser
    },
  },
  methods: {
    ...mapActions(useAuthStore, ['logout']),
  },
    mounted() {
    // Делаем toast методы доступными глобально
    this.$root.$toast = {
      success: (message) => this.$refs.toast.showToast(message, 'success'),
      error: (message) => this.$refs.toast.showToast(message, 'error')
    };
    registerAppToast(this.$root.$toast);

    axios.interceptors.response.use((response) => {
      return response;
    }, (error) => {
      console.error(error)
      // Ответа может не быть вовсе (обрыв сети, отменённый запрос) — тогда
      // разбирать статус нечего, ошибку просто отдаём дальше вызывающему коду
      const status = error.response?.status
      if (status === 401 || status === 419) {
        if (error.response?.data?.message === 'CSRF token mismatch.') return
        this.logout()
          .catch((error) => {
            console.error(error)
          })
        router.replace({name: 'Login'})
      } else if (status === 403) {
        // На подтверждение почты ведёт только отказ middleware `verified`. Остальные 403 —
        // отказ по правам роли (module-access, section-access, авторизация Form Request):
        // пользователь остаётся на странице и видит причину
        const message = error.response?.data?.message
        if (message === 'Your email address is not verified.') {
          router.push({name: 'VerifyEmail'})
        } else {
          const isDefaultText = !message || message === 'This action is unauthorized.'
          this.$root.$toast?.error(isDefaultText ? 'Недостаточно прав для этого действия' : message)
        }
      } else if (status === 423) {
        router.push({name: 'ConfirmPassword'})
      }

      return Promise.reject(error);
    });
    const currentId = this.currentUser?.id;
    if (!currentId) {
      return;
    }

    // Состояние уведомлений: периодический опрос счётчика + регистрация Web Push
    const notificationsStore = useNotificationsStore();
    notificationsStore.startPolling();

    const {registerAndSubscribe} = usePushNotifications();
    registerAndSubscribe();

    // Приватный канал пользователя — мгновенные уведомления через WebSocket
    echoInstance.private(`user.${currentId}`)
      .listen('.new-notification', (e) => {
        notificationsStore.handleIncomingNotification();
        this.$refs.notificationToast?.show({ id: e.id, title: e.title, message: e.message, url: e.entity_url || null });
      });
  },
}
</script>
